import axios from 'axios'

export default class Report {
  endpoint = process.env.VUE_APP_API_URL + 'reports'

  dashboard (period, date) {
    return axios.get(this.endpoint + '/dashboard', {
      params: {
        period: period,
        date: date
      }
    }).then(response => response.data)
  }

  fetch (type, period, date) {
    return axios.get(this.endpoint + '/' + type, {
      params: {
        period: period,
        date: date
      }
    }).then(response => response.data)
  }

  repairs (period, date) {
    return this.fetch('repairs', period, date)
  }

  stocks () {
    return axios.get(this.endpoint + '/stocks').then(response => response.data)
  }
}
